import React from 'react';

export default () => (
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.81818 3.27273C9.81818 1.46455 8.35364 0 6.54545 0C4.73727 0 3.27273 1.46455 3.27273 3.27273C3.27273 5.08091 4.73727 6.54545 6.54545 6.54545C8.35364 6.54545 9.81818 5.08091 9.81818 3.27273ZM11.4545 4.90909V6.54545H13.9091V9H15.5455V6.54545H18V4.90909H15.5455V2.45455H13.9091V4.90909H11.4545ZM0 11.4545V13.0909H13.0909V11.4545C13.0909 9.27818 8.73 8.18182 6.54545 8.18182C4.36091 8.18182 0 9.27818 0 11.4545Z" fill="currentColor" />
  </svg>

);
